import PropTypes from "prop-types";

import { ChallengeDetailCard } from "./ChallengeDetailCard";

function ChallengeResultRows({ challengeData, handleItemClick, selectedItem }) {
  let paddingOffset = 0;
  return (
    <div className="challenge-result-rows">
      {challengeData?.runs?.map((item, index) => {
        const type = item?.type;
        const isResult = type === "result";
        if (type === "extraction") {
          paddingOffset = 10 * index;
        } else if (isResult) {
          paddingOffset = 0;
        }
        item["heading"] = (
          <>
            {`${index > 1 ? "Re-" : ""}${
              type?.charAt(0).toUpperCase() + type?.slice(1)
            } by `}
            <strong>{item?.model}</strong>
          </>
        );
        return (
          <ChallengeDetailCard
            key={index + 1}
            padding={paddingOffset}
            data={item}
            onClick={() =>
              handleItemClick(index + 1, item?.title, item?.result)
            }
            isActive={selectedItem?.index === index + 1}
          />
        );
      })}
    </div>
  );
}

ChallengeResultRows.propTypes = {
  challengeData: PropTypes.object.isRequired,
  handleItemClick: PropTypes.func.isRequired,
  selectedItem: PropTypes.object.isRequired,
};

export { ChallengeResultRows };
